import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import SectionLine from "@/common/components/_UI/SectionLine"

import WalletSDKDark from "@/common/assets/image/products/icons/WalletSDKDark.svg"
import DescriptionImage from "@/common/assets/image/products/wallet/sdk/Description.webp"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import Description from "@/common/components/Description"
import ProductCTA from "@/common/components/ProductCTA"
import ProductViewMore from "@/common/components/ProductViewMore"
import { ProductBanner } from "@/common/components/ProductBanner"
import { ProductNames, SolutionNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"
import NextImg from "@/common/components/NextImg"

const WalletSDKPage = () => {
  const { t } = useTranslation(["walletSDK"])
  const { t: commonT } = useTranslation(["common"])

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products/wallet-sdk"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products/wallet-sdk"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products/wallet-sdk"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products/wallet-sdk"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          icon={WalletSDKDark.src}
          bannerType={ProductNames.WalletSDK}
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          description={t("Banner.description")}
        />
        <SectionLine />
        <Description
          items={[
            {
              element: (
                <NextImg
                  style={{ width: "80%" }}
                  src={DescriptionImage.src}
                  alt="DescriptionImage"
                />
              )
            },
            {
              titles: [{ text: t("Desc.1.title"), textType: "h3" }],
              content: t("Desc.1.content"),
              contentBorder: false,
              checkList: [
                {
                  listColor: "lightGray",
                  list: [
                    { description: t("Desc.1.checkList.0") },
                    { description: t("Desc.1.checkList.1") },
                    { description: t("Desc.1.checkList.2") }
                  ]
                }
              ]
            },
            {
              titles: [{ text: t("Desc.2.title"), textType: "h3" }],
              content: t("Desc.2.content")
            },
            {
              titles: [{ text: t("Desc.3.title"), textType: "h3" }],
              content: t("Desc.3.content")
            },
            {
              titles: [{ text: t("Desc.4.title"), textType: "h3" }],
              content: t("Desc.4.content")
            }
          ]}
        />
        <ProductCTA
          title={t("CTA.title")}
          desc={t("CTA.description")}
          primaryButton={{ text: t("CTA.button") }}
        />
        <ProductViewMore
          commonT={commonT}
          title={commonT("ViewMore.title")}
          tab={[
            {
              name: commonT("ViewMore.products"),
              content: [
                ProductNames.WalletBuilder,
                ProductNames.WalletApplication
              ]
            },
            {
              name: commonT("ViewMore.solutions"),
              content: [SolutionNames.GameFi, SolutionNames.Defi]
            }
          ]}
          actionText={commonT("ViewMore.allProducts")}
        ></ProductViewMore>
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "walletSDK"
    ]))
  }
})

export default WalletSDKPage
